export const SECTIONS_LOADED = "SECTIONS_LOADED";
export const DEFAULT_ROUTES_LOADED = "DEFAULT_ROUTES_LOADED";
export const SECTIONS_DEPOT_STATS_LOADED = "SECTIONS_DEPOT_STATS_LOADED";

export const sectionsLoaded = (sections) => ({
  type: SECTIONS_LOADED,
  payload: sections,
});

export const defaultRoutesLoaded = (defaultRoutes) => ({
  type: DEFAULT_ROUTES_LOADED,
  payload: defaultRoutes,
});

export const sectionsDepotStatsLoaded = (depotStats) => ({
  type: SECTIONS_DEPOT_STATS_LOADED,
  payload: depotStats,
});

export const successSectionsFetch = (data) => async (dispatch) => {
  const sections = data.section.reduce((acc, item) => {
    acc[item.sectionCode] = item;
    return acc;
  }, {});

  const defaultRoutes = data.defaultRoutes.reduce((acc, route) => {
    acc[route.routeId] = route;
    return acc;
  }, {});

  dispatch(sectionsLoaded(sections));
  dispatch(defaultRoutesLoaded(defaultRoutes));
  dispatch(sectionsDepotStatsLoaded(data.depotStats));
};
